/**
 * card-button-names.js
 *
 * Gives each product card action (Quick view, Compare, Quick shop) a unique
 * accessible name by appending the product title. The buttons are also injected
 * from a JS template, so a single script covers every card layout.
 */
(function () {
  'use strict';

  var BTNS = '.t4s-pr-quickview, .t4s-pr-compare, .t4s-pr-addtocart, .t4s-pr-wishlist';

  function label(btn) {
    var card = btn.closest('.t4s-product');
    var link = card && card.querySelector('.t4s-product-title a');
    var text = btn.querySelector('.t4s-text-pr');
    var title = link && link.textContent.trim();
    if (!title || !text) return;
    var base = text.textContent.trim();
    if (!base) return;
    btn.setAttribute('aria-label', base + ' “' + title + '”');
    btn.dataset.nameWired = 'true';
  }

  function init() {
    var all = document.querySelectorAll('.t4s-product ' + BTNS.split(', ').join(', .t4s-product '));
    for (var i = 0; i < all.length; i++) {
      if (all[i].dataset.nameWired !== 'true') label(all[i]);
    }
  }

  function start() {
    init();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () { scheduled = false; init(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
